import React, { useEffect } from "react";

import useLayoutStore from "stores/useLayoutStore";
import { Error404 } from "containers/Error/Error404";
const Error404Page = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <Error404 />
    </>
  );
};

export default Error404Page;
